<div *ngFor="let element of data">
  <app-list-view-item [element]="element"></app-list-view-item>
</div>
